export enum WorkerType {
  image = "image",
  text = "text",
  interrogation = "interrogation",
}
